import http from '@/utils/http' //引入axios
export const getRejectiontype = data => http.get('/rvm-center/api/rejectiontype', {
    params: data
}) //查找条码
export const updataRejectiontype = data => http.put('/rvm-center/api/rejectiontype', data) //編輯条码
export const addRejectiontype = data => http.post('/rvm-center/api/rejectiontype', data) //添加条码
export const deleteRejectiontype = data => http.delete('/rvm-center/api/rejectiontype', {
    params: data
}) //根据barcodes刪除条码
// export  const findBarcode = data=>http.get('/api/district/superior',{params:data}) //查找部门
export default {
    getRejectiontype,
    updataRejectiontype,
    addRejectiontype,
    deleteRejectiontype,
    // findBarcode
}